var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5878 12C19.5878 7.58172 16.0799 4 11.7526 4C7.4254 4 3.91748 7.58172 3.91748 12C3.91748 16.4183 7.4254 20 11.7526 20C16.0799 20 19.5878 16.4183 19.5878 12ZM8.0588 8.22849C8.37444 7.91932 8.88095 7.92456 9.19011 8.2402L11.7513 10.855L14.3118 8.24096C14.621 7.92532 15.1275 7.92008 15.4431 8.22924C15.7588 8.53841 15.764 9.04492 15.4548 9.36056L12.8712 11.9983L15.4548 14.636C15.764 14.9516 15.7587 15.4581 15.4431 15.7673C15.1275 16.0764 14.621 16.0712 14.3118 15.7556L11.7513 13.1415L9.19015 15.7563C8.88098 16.072 8.37448 16.0772 8.05884 15.768C7.7432 15.4589 7.73796 14.9524 8.04713 14.6367L10.6315 11.9983L8.04709 9.3598C7.73792 9.04416 7.74317 8.53766 8.0588 8.22849Z",
    fill: "#928CA6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.195411b6bb24583495ee5f52a0337e29.svg";
export { ForwardRef as ReactComponent };